<template>
    <div>
        <!-- 查询 -->
        <el-form :inline="true" :model="query" class="query-form" size="mini">

            <el-form-item label="公司名称:" class="query-form-item">
                <el-select v-model="query.companyName" filterable remote reserve-keyword placeholder="请输入至少三个字母"
                    :remote-method="remoteMethod" allow-create default-first-option @blur="query.companyName = $event.target.value.trim()">
                    <!-- 点击回车键自动选择第一个自己创建的选项 -->
                    <el-option v-for="item in companyQueryOptions" :key="item.id" :label="item.companyName"
                        :value="item.companyName">
                    </el-option>
                </el-select>
                <!-- <el-autocomplete v-model="query.companyName" :fetch-suggestions="remoteMethod" placeholder="请输入内容"></el-autocomplete> -->
            </el-form-item>
            <el-form-item label="公司类型">
                <el-select v-model="query.typeName" placeholder="选择公司类型">
                    <el-option label="ALL" value="">ALL</el-option>
                    <el-option label="普通公司" value="company">普通公司</el-option>
                    <el-option label="基金公司" value="fund-mix">基金公司</el-option>
                </el-select>    
            </el-form-item>
            <el-form-item label="公司类型:" class="query-form-item">
                <el-select v-model="query.type" placeholder="选择公司类型">
                    <el-option label="Company" value="Company"></el-option>
                    <!-- <el-option label="Holding Business" value="Holding Business"></el-option>
                    <el-option label="Investment Company" value="Investment Company"></el-option> -->
                    <el-option label="Fund Management Business" value="Fund Management Business"></el-option>
                    <el-option label="Fund" value="Fund"></el-option>
                    <el-option label="Fund-SP" value="Fund-SP"></el-option>
                    <el-option label="LP" value="LP"></el-option>
                    <el-option label="Foundation" value="Foundation"></el-option>
                    <el-option label="Other" value="Other"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="管辖区域:">
                <el-select v-model="query.jurisdiction">
                    <el-option v-for="item in jurisdictionList" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-form-item label="代理公司:">
                    <el-select v-model="query.agent">
                        <el-option v-for="item in agentCompanyList" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click.native="handleForm(null, null)">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <!-- 公司列表 -->
        <el-table id="out-table" v-loading="loading" :data="list" style="width: 100%">
            <el-table-column label="公司 ID" prop="id" min-width="50%">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="公司名称" prop="companyName" min-width="200%">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="公司类型" prop="type" min-width="100%">
            </el-table-column>
            <el-table-column label="管辖区域" prop="jurisdiction" min-width="100%">
            </el-table-column>
            <el-table-column label="注册日期" prop="registrationDate" min-width="100%">
            </el-table-column>
            <el-table-column label="注册编号" prop="registrationNum" min-width="100%">
            </el-table-column>
            <el-table-column label="代理公司" prop="agent" min-width="100%">
            </el-table-column>
            <el-table-column label="年检月份" prop="annualReviewMonth" min-width="100%" align="center">
            </el-table-column>
            <el-table-column label="年检启动时间" prop="annualReviewStart" min-width="100%" align="center">
            </el-table-column>
            <el-table-column label="付款人" prop="remitter" min-width="100%" align="center">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="250px">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">
                        <i class="el-icon-edit">编辑</i>
                    </el-button>
                    <!-- <el-button
                            type="text"
                            size="small"
                            @click="
                                showAnnualReviewInfo(scope.$index, scope.row)
                            "
                        >
                            <i class="el-icon-info">年检列表</i>
                        </el-button> -->
                    <el-button type="text" size="small" @click="
                            toCompanyAnnualReviewInfo(scope.$index, scope.row)
                        ">
                        <i class="el-icon-info">年检</i>
                    </el-button>
                    <el-button type="text" size="small" @click="showInvoice(scope.$index, scope.row)">
                        <i class="el-icon-info">发票</i>
                    </el-button>
                    <!-- <el-button v-show="!scope.row.isDelete" type="text" size="small"
                        @click="changeIsDelete(scope.$index, scope.row)"><i class="el-icon-delete">删除</i>
                    </el-button> -->
                    <el-button type="text" size="small"
                        @click="showDeleteDialog(scope.$index, scope.row)">
                        <i class="el-icon-delete">删除</i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination :current-page="query.page" :page-size="query.limit" @current-change="handleCurrentChange"
            layout="prev, pager, next" :total="total">
        </el-pagination>

        <!--编辑公司表单-->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="65%"
            :close-on-click-modal="false" class="company-backgroundColor">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-col :span="12">
                    <el-form-item label="公司 ID" label-width="150px" label-position="left">
                        <el-input style="width: 215px" type="" v-model="formData.id" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" prop="companyName" label-width="150px" label-position="left">
                        <span slot="label">
                            <span style="color: green"><strong>公司名称</strong>
                            </span>
                        </span>
                        <el-input @blur="trimInputContent($event)" v-model="formData.companyName" auto-complete="off"
                            style="width: 350px"></el-input>
                    </el-form-item>
                    <el-form-item label-width="150px" label="公司类型" prop="type">
                        <el-select v-model="formData.type" placeholder="请选择公司类型">
                            <!-- <el-option
                                label="Holding Business"
                                value="Holding Business"
                            ></el-option>
                            <el-option
                                label="Investment Company"
                                value="Investment Company"
                            ></el-option> -->
                            <el-option label="Company" value="Company"></el-option>
                            <el-option label="Fund Management Business" value="Fund Management Business"></el-option>
                            <el-option label="Fund" value="Fund"></el-option>
                            <el-option label="Fund-SP" value="Fund-SP"></el-option>
                            <el-option label="LP" value="LP"></el-option>
                            <el-option label="Foundation" value="Foundation"></el-option>
                            <el-option label="Other" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管辖区域" label-width="150px" label-position="left">
                        <el-select v-model="formData.jurisdiction" placeholder="请选择管辖区域">
                            <el-option label="BVI" value="BVI"></el-option>
                            <el-option label="Cayman" value="Cayman"></el-option>
                            <el-option label="Seychelles" value="Seychelles"></el-option>
                            <el-option label="USA" value="USA"></el-option>
                            <el-option label="Hong Kong" value="Hong Kong"></el-option>
                            <el-option label="Singapore" value="Singapore"></el-option>
                            <el-option label="Japan" value="Japan"></el-option>
                            <el-option label="New Zealand" value="New Zealand"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="代理公司" label-width="150px" label-position="left">
                        <el-select v-model="formData.agent" placeholder="请选择代理公司">
                            <el-option label="CIA" value="CIA"></el-option>
                            <el-option label="ICS" value="ICS"></el-option>
                            <el-option label="Richful Deyong" value="Richful Deyong"></el-option>
                            <el-option label="Vistra" value="Vistra"></el-option>
                            <el-option label="Loeb Smith" value="Loeb Smith"></el-option>
                            <el-option label="Careyolsen" value="Careyolsen"></el-option>
                            <el-option label="Harneys" value="Harneys"></el-option>
                            <el-option label="Other" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="负责人" prop="companyDirector" label-width="150px" label-position="left">
                        <el-input @blur="trimInputContent($event)" v-model="formData.companyDirector" auto-complete="off"
                            style="width: 350px"></el-input>
                    </el-form-item>
                    <el-form-item label="常用付款人/Remitter" prop="remitter" label-width="150px" label-position="left">
                        <el-input @blur="trimInputContent($event)" v-model="formData.remitter" auto-complete="off"
                            style="width: 350px"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="companyRemarks" label-width="150px" label-position="left">
                        <el-input @blur="trimInputContent($event)" v-model="formData.companyRemarks" auto-complete="off"
                            style="width: 350px"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="注册日期" label-width="150px" label-position="left">
                        <el-date-picker v-model="formData.registrationDate" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="注册编号" label-width="150px" label-position="left">
                        <el-input type="" @blur="trimInputContent($event)" v-model="formData.registrationNum"
                            style="width: 215px"></el-input>
                    </el-form-item>
                    <el-form-item label="年检月份" label-width="150px" label-position="left">
                        <el-select v-model="formData.annualReviewMonth" placeholder="请选择年检月份"
                            @change="onChangeMonth(formData.annualReviewMonth)">
                            <el-option v-for="item in monthList" :label="item" :value="item" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="年检启动时间" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.annualReviewStart" disabled style="width: 215px"></el-input>
                    </el-form-item>
                    <el-form-item label="雇员" label-width="150px" label-position="left">
                        <el-input type="" @blur="trimInputContent($event)" v-model="formData.employee"
                            style="width: 215px"></el-input>
                    </el-form-item>
                    <el-form-item label="相关活动" label-width="150px" label-position="left">
                        <el-select v-model="formData.relevantActivity" placeholder="请选择相关活动">
                            <el-option v-for="item in relevantActivityList" :label="item" :value="item"
                                :key="item"></el-option>
                            <el-option label="Other" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="渠道" label-width="150px" label-position="left">
                        <el-input type="" @blur="trimInputContent($event)" v-model="formData.channel"
                            style="width: 300px"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>

        <!-- 发票列表 -->
        <el-dialog :visible="invoiceVisible" @close="invoiceVisible = false" width="80%" top="5vh">
            <div style="text-align: center; margin-bottom: 30px">
                <h2>{{ invoiceTitle }} 发票信息</h2>
            </div>
            <div v-show="invoiceList.length !== 0">
                <h3>收入发票：</h3>
                <el-table :data="invoiceList">
                    <el-table-column label="序号" type="index" min-width="50%">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" label="Company" prop="company" min-width="150%">
                    </el-table-column>
                    <el-table-column label="Detail" min-width="250%">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.detailService | cutDetail }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="status" min-width="90%">
                        <template slot-scope="scope"><span>
                                {{ scope.row.status | statusFilterStatus }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Date" min-width="90%">
                        <template slot-scope="scope">
                            <i class="el-icon-s-flag" title="开具时间"></i>
                            <span>{{ scope.row.invoiceDate }}</span><br />
                            <i class="el-icon-check" title="到账时间"></i>
                            <span>{{ scope.row.receiptDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="TotalAmount" min-width="90%">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.currency }}
                                {{ scope.row.totalAmount | numFilter }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="invoiceNo" prop="invoiceNo" min-width="170%">
                        <template slot-scope="{ row }">
                            <el-link @click="showInvoiceNo(row.invoiceNo)">{{
                                row.invoiceNo
                                }}</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page="invoiceQuery.page" :page-size="invoiceQuery.limit"
                    @current-change="invoicePageChange" layout="prev, pager, next" :total="invoiceTotal">
                </el-pagination>
            </div>

            <div v-show="costInvoiceList.length !== 0" style="margin-top: 10px">
                <h3>成本发票：</h3>
                <el-table :data="costInvoiceList">
                    <el-table-column label="序号" type="index" min-width="50%">
                    </el-table-column>
                    <el-table-column label="Company" prop="company" min-width="150%">
                    </el-table-column>
                    <el-table-column label="Detail" min-width="250%">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.detailService | cutDetail }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="status" min-width="90%">
                        <template slot-scope="scope"><span>
                                {{ scope.row.status | statusFilterStatus }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Date" min-width="90%">
                        <template slot-scope="scope">
                            <i class="el-icon-s-flag" title="开具时间"></i>
                            <span>{{ scope.row.invoiceDate }}</span><br />
                            <i class="el-icon-check" title="到账时间"></i>
                            <span>{{ scope.row.receiptDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="TotalAmount" min-width="90%">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.currency }}
                                {{ scope.row.totalAmount | numFilter }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="invoiceNo" prop="invoiceNo" min-width="170%">
                        <template slot-scope="{ row }">
                            <el-link @click="showCostInvoiceNo(row.invoiceNo)">{{ row.invoiceNo }}</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page="costInvoiceQuery.page" :page-size="costInvoiceQuery.limit"
                    @current-change="costInvoicePageChange" layout="prev, pager, next" :total="costInvoiceTotal">
                </el-pagination>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="invoiceVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看 -->
        <el-dialog width="80%" @close="closeCostInvoiceNo" class="abow_dialog" :visible="costInvoiceNoVisible">
            <viewCostInvoice :key="new Date().getTime()" :costInvoiceNoForm="costInvoiceNoForm"></viewCostInvoice>
        </el-dialog>

        <el-dialog width="80%" @close="closeInvoiceNo" class="abow_dialog" :visible="invoiceNoVisible">
            <viewInvoice :key="new Date().getTime()" :invoiceNoForm="invoiceNoForm"></viewInvoice>
        </el-dialog>

        <!-- 删除确认框 -->
        <el-dialog title="提示" :visible.sync="deleteDialogVisible" width="30%" @close="deleteDialogClose">
            <span>确定要删除该条记录嘛？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogClose">取 消</el-button>
                <el-button type="primary" @click="confirmDelete">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import isPaid from "../../assets/image/isPaid.png";
    import noPaid from "../../assets/image/noPaid.png";
    import {
        companyListIndexPage,
        companySaveOrEdit,
        companyDelete,
        companyLikeSearchList,
    } from "../../api/company/company";
    import { authAdminList } from "../../api/auth/authAdmin";

    import { invoiceList } from "../../api/invoice/invoice";

    import { invoiceCostList } from "../../api/invoice/invoiceCost";

    import viewCostInvoice from "@/components/annualReview/viewCostInvoice";
    import viewInvoice from "../../components/annualReview/viewInvoice";

    const formJson = {
        id: "",
        companyName: "",
        jurisdiction: "",
        agent: "",
        annualReviewMonth: "",
        annualReviewStart: "",
        employee: null,
        registrationDate: "",
        relevantActivity: "",
        type: "",
        typeName: "",
        level: "",
        status: "1",
        listorder: 999,
        admins: [],
        companyDirector: "",
        companyRemarks: "",
        remitter:"",
    };

    let recordQuery = null;

    export default {
        data() {
            return {
                // 图片
                isPaidImg: isPaid,
                noPaidImg: noPaid,
                // 查询
                agentCompanyList: [
                    "ALL",
                    "ALL AGENT",
                    "ICS",
                    "CIA",
                    "Richful Deyong",
                    "Vistra",
                    "Loeb Smith",
                    "Careyolsen",
                    "Harneys",
                    "Other",
                ],
                jurisdictionList: [
                    "ALL",
                    "BVI",
                    "Cayman",
                    "Seychelles",
                    "Singapore",
                    "Hong Kong",
                    "China",
                    "New Zealand",
                    "Japan",
                ],
                query: {
                    companyCategory: "",
                    companyName: "",
                    jurisdiction: "ALL",
                    typeName: "",
                    // agent: "ALL AGENT",
                    agent: "ALL",
                    page: 1,
                    limit: 10,
                },
                list: [],
                total: 0,
                loading: true,
                authList: [],
                admins: [],
                defaultProps: {
                    children: "children",
                    label: "title",
                },
                index: null,
                formName: null,
                formMap: {
                    add: "新增公司信息",
                    edit: "编辑公司信息",
                },
                formLoading: false,
                formVisible: false,
                formData: formJson,
                formRules: {
                    name: [
                        { required: true, message: "请输入名称", trigger: "blur" },
                    ],
                },
                deleteLoading: false,
                // 年检月份
                monthList: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                // 相关活动
                relevantActivityList: [
                    "Pure Equity Holding Business(Holding companies)纯控股业务（控股公司）",
                    "Fund Management Business基金管理业务",
                    "Other: Investment Company 其他: 投资公司",
                    "Dormant休眠状态",
                    "Banking Business银行业务",
                    "Shipping Business运输业务",
                    "Insurance Business保险业务",
                    "Financing and Leasing Business融资租赁业务",
                    "Headquarter Business总部业务",
                    "Distribution and Service Centre Business分销和服务中心业务",
                    "Intellectual Property知识产权",
                ],

                // 记录公司id,name
                recordCompanyId: 0,
                recordCompanyName: "",

                invoiceVisible: false,

                invoiceQuery: {
                    page: 1,
                    limit: 5,
                },
                invoiceList: [],
                invoiceTotal: 0,
                costInvoiceList: [],
                costInvoiceQuery: {
                    page: 1,
                    limit: 5,
                },
                costInvoiceTotal: 0,

                recordInvoiceCompany: "",

                // 查看
                invoiceNoVisible: false,
                invoiceNo: "",
                invoiceNoQuery: {
                    invoiceNo: "",
                    page: 1,
                    limit: 10,
                },
                invoiceNoForm: {},

                costInvoiceNoVisible: false,
                costInvoiceNo: "",
                costInvoiceNoQuery: {
                    invoiceNo: "",
                    page: 1,
                    limit: 10,
                },
                costInvoiceNoForm: {},

                // 发票标题
                invoiceTitle: "",

                fromPage: "company",

                // company查询
                companyQuery: {
                    companyName: "",
                    page: 1,
                    limit: 50,
                },
                companyQueryOptions: [],

                // 删除确认框
                deleteDialogVisible: false,

                recordDeleteIndex: undefined,
                recordDeleteRow: null
            };
        },
        components: {
            viewCostInvoice,
            viewInvoice,
        },
        methods: {
            onReset() {
                this.$router.push({
                    path: "",
                });
                this.query = {
                    companyName: "",
                    jurisdiction: "ALL",
                    typeName: "",
                    // agent: "ALL AGENT",
                    agent: "ALL",
                    status: "",
                    page: 1,
                    limit: 10,
                };
                this.getList();
            },
            onSubmit() {
                this.query.page = 1;
                this.getList();
            },

            // company查询
            remoteMethod(companyName) {
                if (companyName.length < 3) {
                    return;
                }

                this.companyQuery.companyName = companyName;
                companyLikeSearchList(this.companyQuery)
                    .then((response) => {
                        this.companyQueryOptions = response.data.list;

                        // cb(this.companyQueryOptions);
                    })
                    .catch(() => { });
            },

            handleCurrentChange(val) {
                this.query.page = val;
                this.getList();
            },
            getList() {
                this.loading = true;
                companyListIndexPage(this.query)
                    .then((response) => {
                        this.loading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.list = response.data.list || [];
                        this.total = response.data.total || 0;

                        // this.list.forEach((item) => {
                        //     // item.isDelete = false;
                        //     this.$set(item, "isDelete", false);
                        // });
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.total = 0;
                    });
            },
            getAuthAdminList() {
                authAdminList(this.query)
                    .then((response) => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.admins = response.data.list || [];
                    })
                    .catch(() => { });
            },
            // 刷新表单
            resetForm() {
                if (this.$refs["dataForm"]) {
                    // 清空验证信息表单
                    this.$refs["dataForm"].clearValidate();
                    // 刷新表单
                    this.$refs["dataForm"].resetFields();
                }
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                return true;
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                this.formData = JSON.parse(JSON.stringify(formJson));
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                this.formName = "add";
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                }
            },
            formSubmit() {
                this.$refs["dataForm"].validate((valid) => {
                    if (valid) {
                        this.formLoading = true;

                        for (let key of Object.keys(this.formData)) {
                            if (typeof this.formData[key] == "string") {
                                this.$set(
                                    this.formData,
                                    key,
                                    this.formData[key].trim()
                                );
                            }
                        }
                        let data = Object.assign({}, this.formData);
                        companySaveOrEdit(data, this.formName)
                            .then((response) => {
                                this.formLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success(response.message);
                                this.formVisible = false;
                                if (this.formName === "add") {
                                    // 向头部添加数据
                                    if (response.data && response.data.id) {
                                        data.id = response.data.id;
                                        this.list.unshift(data);
                                    }
                                } else {
                                    this.list.splice(this.index, 1, data);
                                }
                                // 刷新表单
                                this.resetForm();
                            })
                            .catch(() => {
                                this.formLoading = false;
                                this.$message.error("保存失败!");
                            });
                    }
                });
            },
            // changeIsDelete(index, row) {
            //     // this.$set(this.list[index], "isDelete", true);
            //     this.$confirm("确认要删除吗？", "提示", {
            //         type: "warning",
            //     })
            //         .then(() => {
            //             this.list[index].isDelete = true;
            //         })
            //         .catch(() => {
            //             this.$message.error("取消删除");
            //         });
            // },
            // 删除
            deleteForm(index, row) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        companyDelete({ id: row.id })
                            .then((response) => {
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success(response.message);
                                this.deleteDialogVisible = false;
                                // 刷新数据
                                this.list.splice(index, 1);

                                this.getList();
                            })
                            .catch(() => { });
                    })
                    .catch(() => {
                        this.$message.error("取消删除");
                        this.deleteDialogVisible = false;
                        // this.list[index].isDelete = false;
                    });
            },

            deleteDialogClose() {
                this.deleteDialogVisible = false;
            },
            showDeleteDialog(index, row) {
                this.deleteDialogVisible = true;

                // 记录删除所需信息
                this.recordDeleteIndex = index;
                this.recordDeleteRow = Object.assign({}, row);
            },
            confirmDelete() {
                this.deleteForm(this.recordDeleteIndex, this.recordDeleteRow);
            },

            // month
            onChangeMonth(value) {
                let startMonthIndex = this.monthList.indexOf(value);
                if (startMonthIndex === 1) {
                    this.formData.annualReviewStart = "December";
                } else if (startMonthIndex === 0) {
                    this.formData.annualReviewStart = "November";
                } else {
                    this.formData.annualReviewStart =
                        this.monthList[startMonthIndex - 2];
                }
            },

            // 跳转
            toCompanyAnnualReviewInfo(index, row) {
                recordQuery = Object.assign({}, this.query);
                this.$router.push({
                    path: "/company/companyAnnualReviewInfo",
                    query: {
                        companyId: row.id,
                        companyName: row.companyName,
                        fromPage: this.fromPage,
                    },
                });
            },
            // 相关发票
            getInvoiceList(company) {
                this.invoiceQuery.company = company;
                invoiceList(this.invoiceQuery).then((response) => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.invoiceList = response.data.list;
                    this.invoiceTotal = response.data.total;
                });
            },
            getCostInvoceList(company) {
                this.costInvoiceQuery.company = company;
                invoiceCostList(this.costInvoiceQuery).then((response) => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.costInvoiceList = response.data.list;
                    this.costInvoiceTotal = response.data.total;
                });
            },
            // 相关发票
            async showInvoice(index, row) {
                this.invoiceQuery.page = 1;
                this.costInvoiceQuery.page = 1;
                this.recordInvoiceCompany = row.companyName;

                this.invoiceTitle = row.companyName;

                this.invoiceQuery.company = this.recordInvoiceCompany;
                let invoiceResponse = await invoiceList(this.invoiceQuery);
                if (invoiceResponse.code) {
                    this.$message.error(invoiceResponse.message);
                    return false;
                }
                this.invoiceList = invoiceResponse.data.list;

                this.costInvoiceQuery.company = this.recordInvoiceCompany;
                let costInvoiceResponse = await invoiceCostList(
                    this.costInvoiceQuery
                );
                if (costInvoiceResponse.code) {
                    this.$message.error(costInvoiceResponse.message);
                    return false;
                }
                this.costInvoiceList = costInvoiceResponse.data.list;

                if (
                    this.costInvoiceList.length === 0 &&
                    this.invoiceList.length === 0
                ) {
                    this.$message("没有相关发票信息 !");
                    this.invoiceVisible = false;
                } else {
                    this.invoiceVisible = true;
                }
            },
            invoicePageChange(pager) {
                this.invoiceQuery.page = pager;
                this.getInvoiceList(this.recordInvoiceCompany);
            },
            costInvoicePageChange(pager) {
                this.costInvoiceQuery.page = pager;
                this.getCostInvoceList(this.recordInvoiceCompany);
            },

            // 查看收入发票
            showInvoiceNo(invoiceNo) {
                this.invoiceNo = invoiceNo;
                this.invoiceNoQuery.invoiceNo = this.invoiceNo;
                invoiceList(this.invoiceNoQuery).then((response) => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    if (response.data.list.length === 0) {
                        this.$message.info("没有该发票信息");
                        return false;
                    }
                    this.invoiceNoVisible = true;
                    this.invoiceNoForm = Object.assign({}, response.data.list[0]);
                    console.log(this.invoiceNoForm, "invoiceNoForm");
                });
            },
            closeInvoiceNo() {
                this.invoiceNoVisible = false;
            },

            // 查看成本发票
            showCostInvoiceNo(costInvoiceNo) {
                this.costInvoiceNo = costInvoiceNo;
                this.costInvoiceNoQuery.invoiceNo = this.costInvoiceNo;
                invoiceCostList(this.costInvoiceNoQuery).then((response) => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    if (response.data.list.length === 0) {
                        this.$message.info("没有该发票信息");
                        return false;
                    }
                    this.costInvoiceNoVisible = true;
                    this.costInvoiceNoForm = Object.assign(
                        {},
                        response.data.list[0]
                    );
                    console.log(this.costInvoiceNoForm, "costInvoiceNoForm");
                });
            },
            closeCostInvoiceNo() {
                this.costInvoiceNoVisible = false;
            },

            // trim
            trimInputContent(event) {
                event.target.value = event.target.value.trim();
            },
        },
        filters: {
            statusFilterType(status) {
                const statusMap = {
                    0: "gray",
                    1: "success",
                };
                return statusMap[status];
            },
            // 金额
            numFilter(value) {
                if (value == 0) {
                    let realvalue = Number(value)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                    return realvalue;
                }
                if (
                    value != null &&
                    value != "" &&
                    value != undefined &&
                    value != "--"
                ) {
                    let realvalue = Number(value)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                    return realvalue;
                }
            },
            cutDetail(detail) {
                if (detail != null && detail.length > 60) {
                    detail = detail.substr(0, 115) + "...";
                }
                return detail;
            },
            statusFilterStatus(status) {
                if (status == "Disabled") {
                    return "作废";
                } else if (status == "Created") {
                    return "新建";
                } else if (status == "Audit") {
                    return "已审核";
                } else if (status == "Sent") {
                    return "已发客户";
                } else if (status == "Paid") {
                    return "客户已付款";
                } else if (status == "Received") {
                    return "已到账";
                } else {
                    return "---";
                }
            },
            statusFilterName(status) {
                const statusMap = {
                    0: "禁用",
                    1: "正常",
                    2: "未验证",
                };
                return statusMap[status];
            },
        },
        mounted() { },
        created() {
            if (recordQuery !== null) {
                this.query = Object.assign({}, recordQuery);
            }
            // 加载表格数据
            this.getList();
            this.getAuthAdminList();
        },
        //组件内路由守卫
        beforeRouteEnter(to, from, next) {
            if (from.path !== "/company/companyAnnualReviewInfo") {
                recordQuery = null;
            }
            next();
        },
    };
</script>

<style type="text/scss" lang="scss">
    .el-checkbox-width-company {
    width: 250px;
    height: 15px;
    word-wrap: break-word;
}

.company-backgroundColor .el-dialog__body,
.company-backgroundColor .el-dialog__header,
.company-backgroundColor .el-dialog__footer {
    height: 80%;
    background: rgba(0, 128, 0, 0.05);
}
</style>